module.exports = __webpack_public_path__ + "img/pic2.4d595a46.png";